var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[(_vm.active)?_c('v-col',[(_vm.data.method=='transfer')?_c('Transfer'):_c('Xendit')],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }